<template>
    <div class="visual-item">
        <div class="hexagon-thick">
            <p class="icon icon-schademelden clean"></p>
        </div>
        <h4>Schade melden</h4>
        <p>U heeft schade die u bij ons wilt melden.</p>
        <a class="btn btn-primary" :href="ctx + '/' + schademeldenurl">Schade melden</a>
    </div>
</template>

<script>

    export default {
        name: 'step1schademelden-component',
        props: {
            ctx: String,
            schademeldenurl: String
        },
        data: function () {
            return {
            }
        }
    }

</script>


// WEBPACK FOOTER //
// step1schademelden.vue?07a93e7f